import { Expose } from 'class-transformer';
import {
  BookedStatusEnum,
  EventAudienceEnum,
  EventStatusEnum,
} from '../../../../store/events/eventTypes';

export class EventModel {
  @Expose({ name: 'id' })
  id: number;
  @Expose({ name: 'name' })
  name: string;
  @Expose({ name: 'category_id' })
  categoryId: number;
  @Expose({ name: 'description' })
  description: string;
  @Expose({ name: 'group_id' })
  groupId: number;
  @Expose({ name: 'sub_category_id' })
  subCategoryId: number;
  @Expose({ name: 'free_site_name' })
  freeSiteName: string;
  @Expose({ name: 'resource_id' })
  resourceId: number;
  @Expose({ name: 'audience' })
  audience: EventAudienceEnum;
  @Expose({ name: 'location_id' })
  locationId: number;
  @Expose({ name: 'from_date' })
  fromDate: number;
  @Expose({ name: 'to_date' })
  toDate: number;
  @Expose({ name: 'capacity' })
  capacity: number;
  @Expose({ name: 'status' })
  status: EventStatusEnum;
  @Expose({ name: 'credit_allowed' })
  creditAllowed: boolean;
  @Expose({ name: 'image' })
  image: string;
  @Expose({ name: 'price' })
  price: number;
  @Expose({ name: 'policy_id' })
  policyId: number;
  @Expose({ name: 'catalog_number' })
  catalogNumber: string;
  @Expose({ name: 'booked_status' })
  bookedStatus: BookedStatusEnum;
}
